export const DOCUMENT_TYPE = "documentTypeId";
export const SOURCE_SYSTEM = "sourceSystem";
export const STATUS = "status";
export const STAGE = "stage";
export const DATE_RANGE = "dateRange";
export const SEARCH_VALUE = "searchValue";
export const COMMUNITY_ID = "communityId";
export const DATE_FROM = "dateFrom";
export const DATE_TO = "dateTo";

export const sourceSystemOptions = [
  { label: "All", value: "all" },
  { label: "AR Module", value: 'AR' },
  { label: "AP Module", value: 'AP' },
  { label: "Manual Upload", value: 'MANUAL_JE' },
  { label: "Bank Reconciliation", value: 'BANK' },
  { label: "External Systems", value: 'EXTERNAL' },
];

export const statusOptions = [
  { label: "All", value: "all" },
  { label: "Validation Pass", value: "validation_pass" },
  { label: "Validation Fail", value: "validation_fail" },
  { label: "Business Rule Pass", value: "business_rule_pass" },
  { label: "Business Rule Fail", value: "business_rule_fail" },
  { label: "Summarization Pass", value: "summarization_pass" },
  { label: "Summarization Fail", value: "summarization_fail" },
  { label: "Posting Pass", value: "posting_pass" },
  { label: "Posting Fail", value: "posting_fail" },
];

export const PASS_STATUS = "VALIDATION_PASSED";
export const FAIL_STATUS = "VALIDATION_FAILED";

export const quickInsightsBaseData = [
  {
    title: "Submission",
    stage: 'SUBMISSION',
    wrapperClassName: "border-teal-400",
    headerClassName: "bg-teal-100/60",
    iconClassName: "bg-teal-500/80",
    titleClassName: "text-teal-500/80",
    bodyClassName: "bg-teal-50/30",
    hasSplit: true,
  },
  {
    title: "Validation",
    stage: 'FIELD_VALIDATION',
    wrapperClassName: "border-sky-400",
    headerClassName: "bg-sky-100/60",
    iconClassName: "bg-sky-700/80",
    titleClassName: "text-sky-700/80",
    bodyClassName: "bg-sky-50/30",
    hasSplit: true,
  },
  {
    title: "Business Rules",
    stage: 'BUSINESS_RULES',
    wrapperClassName: "border-rose-400",
    headerClassName: "bg-rose-200/60",
    iconClassName: "bg-rose-700/80",
    titleClassName: "text-rose-700/80",
    bodyClassName: "bg-rose-50",
    hasSplit: true,
  },
  {
    title: "Summarized Line Items",
    stage: 'SUMMARIZATION',
    wrapperClassName: "border-yellow-700/60",
    headerClassName: "bg-yellow-700/20",
    iconClassName: "bg-yellow-700/80",
    titleClassName: "text-yellow-700/80",
    bodyClassName: "bg-yellow-700/10",
  },
  {
    title: "Cost Analytics(Primary Posting)",
    stage: 'COST_ANALYTICS',
    wrapperClassName: "border-green-400",
    headerClassName: "bg-green-200/60",
    iconClassName: "bg-green-700/80",
    titleClassName: "text-green-700/80",
    bodyClassName: "bg-green-50",
  },
  {
    title: "Posted Line Items",
    stage: 'POST',
    wrapperClassName: "border-indigo-400",
    headerClassName: "bg-indigo-200/60",
    iconClassName: "bg-indigo-700/80",
    titleClassName: "text-indigo-700/80",
    bodyClassName: "bg-indigo-50",
  },
  {
    title: "Subledger Entry - Customer",
    stage: 'SUBLEDGER_CUSTOMER',
    wrapperClassName: "border-fuchsia-400",
    headerClassName: "bg-fuchsia-200/60",
    iconClassName: "bg-fuchsia-700/80",
    titleClassName: "text-fuchsia-700/80",
    bodyClassName: "bg-fuchsia-50",
  },
  {
    title: "Subledger Entry - Vendor",
    stage: 'SUBLEDGER_VENDOR',
    wrapperClassName: "border-fuchsia-400",
    headerClassName: "bg-fuchsia-200/60",
    iconClassName: "bg-fuchsia-700/80",
    titleClassName: "text-fuchsia-700/80",
    bodyClassName: "bg-fuchsia-50",
  },
  {
    title: "Secondary Posting - Plans",
    stage: 'SECONDARY_POSTING_PLANS',
    wrapperClassName: "border-fuchsia-400",
    headerClassName: "bg-fuchsia-200/60",
    iconClassName: "bg-fuchsia-700/80",
    titleClassName: "text-fuchsia-700/80",
    bodyClassName: "bg-fuchsia-50",
    hasSplit: true,
    passedLabel: "Income",
    failedLabel: "Expense"
  },
  {
    title: "Secondary Posting - Actuals",
    stage: 'SECONDARY_POSTING_ACTUALS',
    wrapperClassName: "border-fuchsia-400",
    headerClassName: "bg-fuchsia-200/60",
    iconClassName: "bg-fuchsia-700/80",
    titleClassName: "text-fuchsia-700/80",
    bodyClassName: "bg-fuchsia-50",
    hasSplit: true,
    passedLabel: "Income",
    failedLabel: "Expense"
  }
];

export const stageBaseData = [
  {
    title: "Parked",
    stage: 'PARK',
  }
]